import { RootState } from 'store';

const selectFailInn = (state: RootState): string[] => state.contragent.data.failInn;
export default selectFailInn;
